// @import

import { ensureHTMLElement } from "@src/js/lib/ensure";
import { viewport } from "@src/js/lib/viewport";
import Alpine from "alpinejs";

type FormationNavState = {
  inView: boolean;
  isScrollingTop: boolean;
  isMobilePanelOpen: boolean;
};

Alpine.store("formations-nav", {
  inView: false,
  isScrollingTop: false,
  isMobilePanelOpen: false,
} as FormationNavState);

Alpine.directive("formations-nav", (element, {}, { cleanup, effect }) => {
  const state = Alpine.store("formations-nav") as FormationNavState;
  let previousScroll = window.scrollY;

  const dom = {
    mobileTrigger: ensureHTMLElement(element.querySelector(".c-formations-nav__mobile-trigger")),
  };

  function handleScroll() {
    state.isScrollingTop = previousScroll > window.scrollY;
    previousScroll = window.scrollY;
  }

  effect(() => {
    if (state.isScrollingTop || viewport.width < 1024) {
      element.classList.add("c-formations__nav--sticky");
    } else {
      element.classList.remove("c-formations__nav--sticky");
    }
  });

  function toggleMobilePanel() {
    state.isMobilePanelOpen = !state.isMobilePanelOpen;
    if (!state.isMobilePanelOpen) {
      element.classList.remove("c-formations-nav--mobile-open");
    } else {
      element.classList.add("c-formations-nav--mobile-open");
    }
  }

  dom.mobileTrigger.addEventListener("click", toggleMobilePanel);
  window.addEventListener("scroll", handleScroll);

  cleanup(() => {
    window.removeEventListener("scroll", handleScroll);
    dom.mobileTrigger.removeEventListener("click", toggleMobilePanel);
  });
});
